import RestApiModel from "@/api/Model/RestApiModel";

class Underwriter
  extends RestApiModel {
  static getResourceEndpoint() {
    return `/facility-underwriters`;
  }
}

export default Underwriter;
